import React from 'react'
import { rollUpTimeEntries } from '../common/pages/dashboard'
import { withinSpanChecker } from '../util/date_utils'
import * as dateUtils from '../util/date_utils'
import { calculateBigTag } from '../common/components/big_tag'
import TagReportModal from '../components/modals/tag_report_modal'
import { AcceptInviteModal } from '../components/modals/accept_invite_modal'
import {sumTagDurations} from '../common/pages/dashboard'
import TagSidebar from '../components/layout/tag_sidebar'

export default class Dashboard extends React.Component {
    constructor(props) {
        super(props)

        this.getSpanEntries = this.getSpanEntries.bind(this)
        this.handleSelect = this.handleSelect.bind(this)
        this.moveForward = this.moveForward.bind(this)
        this.moveBackward = this.moveBackward.bind(this)
        this.onDayChange = this.onDayChange.bind(this)
        this.calcContainerWidth = this.calcContainerWidth.bind(this)
        this.renderModals = this.renderModals.bind(this)
        this.renderTagSideBar = this.renderTagSideBar.bind(this)

        this.state = {
            showTagReport: false,
            initialReportTag: null,
            tagReportUser: null,
        }
    }

    componentWillMount() {
        this.loadTeamIfNeeded(this.props)
    }

    loadTeamIfNeeded(props) {
        // override
    }

    getSpanEntries(timeEntriesArray) {
        const {start, end} = this.props.viewport.range
        const isWithinRange = withinSpanChecker(start, end)
        return timeEntriesArray.filter(tr => isWithinRange(tr.startAt))
    }

    getRollups(timeEntriesArray, runningEntries) {
        const {range: {increment, start, end}, collapse} = this.props.viewport
        const spanEntries = this.getSpanEntries(timeEntriesArray)
        const interval = collapse ? increment : 'Day'
        return rollUpTimeEntries(spanEntries, interval, {start, end}, runningEntries, collapse)
    }

    onDisplayChange = (chosenDisplayType) => {
        this.props.setDashboardDisplay(chosenDisplayType)
    }

    handleSelect([increment, interval]) {
        const { viewport, setDashboardRange } = this.props
        // If selecting "Today" as an interval, select default Day timespan, Today.
        const selectedInterval = interval === 'Today' ? 'Day' : interval
        const intervalStart = viewport.range.start

        const now = interval === 'Today'
            ? new Date()
            : new Date(intervalStart)
        const newSpan = dateUtils.getDefaultTimespanBackward(selectedInterval, now)

        setDashboardRange({
            // ...this.props.range,
            ...newSpan,
            increment,
            interval: selectedInterval,
        })
    }

    moveForward() {
        const {interval, increment, ...span} = this.props.viewport.range

        const oneForward = dateUtils.moveSpan(span, increment, 1)
        this.props.setDashboardRange({...oneForward, interval, increment})
    }

    moveBackward() {
        const {interval, increment, ...span} = this.props.viewport.range

        const oneBackward = dateUtils.moveSpan(span, increment, -1)
        this.props.setDashboardRange({...oneBackward, interval, increment})
    }

    onDayChange(d) {
        const newSpan = dateUtils.getDefaultTimespan('Day', d)
        this.props.setDashboardRange({...newSpan, interval: 'Day', increment: 'Day'})
    }

    calcContainerWidth() {
        const hPadding = 28 // TODO: determine dynamically
        const container = document.querySelector('.display-container')
        return container ? (container.clientWidth - hPadding) : 0
    }

    toggleTagReport = () => {
        // if model is closing clear initial report tag
        if (this.state.showTagReport) {
            this.setState({initialReportTag: null})
        }
        const show = !this.state.showTagReport
        this.setState({showTagReport: show})
        if (!show) {
            this.props.clearTagReports()
            this.setState({tagReportUser: null})
        }
    }

    reportTag = (foundTag, user) => {
        const {profile, teams} = this.props
        const bigTagMeta = foundTag ? calculateBigTag(foundTag, 0, profile, teams) : undefined
        this.setTagReportUser(user)
        this.setInitialReportTag(bigTagMeta)
        this.toggleTagReport()
    }

    setTagReportUser = (tagReportUser) => {
        this.setState({tagReportUser: tagReportUser})
    }

    setInitialReportTag = (bigTagMeta) => {
        this.setState({initialReportTag: bigTagMeta})
    }

    handleDisableMember = (userId) => {
        const { handleDisableMember, viewport } = this.props
        const { teamId } = viewport

        handleDisableMember({teamId, userId})
    }

    viewerIsTeamAdmin = () => {
        const { profile } = this.props
        const { teamId } = this.props.viewport
        const viewerTeamMembership = profile && profile.memberships[teamId]
        return !!viewerTeamMembership && viewerTeamMembership.accessLevel === 'Admin'
    }

    renderTagSideBar(team, timeEntriesArray) {
        const { tags, profile, newTimeEntry, newTimer, createTag, editTag, updateTag, createInvite,
            newTag, deleteTag, selectedTeamMembership, selectedTeamInvites, teams, deleteInvite,
            goals, customer, accounts, setPaymentModalOpen, updateMemberRole,
        } = this.props

        const teamsMap = teams.items
        const isTeam = !!team && !team.isPersonal
        const { interval, increment, ...span } = this.props.viewport.range
        const account = accounts.items[profile.accountId]
        const accountName = account && account.name || ""
        const trialEnd = customer.trialEnd
        const tagsByDuration = sumTagDurations(timeEntriesArray, span)
        const teamMembers = selectedTeamMembership.sort.reduce( (acc, k) => [...acc, selectedTeamMembership.items[k]], []) || []
        const teamInvites = selectedTeamInvites.sort.reduce( (acc, k) => [...acc, selectedTeamInvites.items[k]], []) || []
        const viewerIsTeamAdmin = this.viewerIsTeamAdmin()

        return (
            <TagSidebar
                isTeam={isTeam}
                accountName={accountName}
                trialEnd={trialEnd}
                setPaymentModalOpen={setPaymentModalOpen}
                team={team}
                tags={tags}
                recentTags={tagsByDuration}
                interval={interval}
                newTimeEntry={newTimeEntry}
                newTimer={newTimer}
                createTag={createTag}
                editTag={editTag}
                updateTag={updateTag}
                deleteTag={deleteTag}
                newTag={newTag}
                reportTag={this.reportTag}
                toggleTagReport={this.toggleTagReport}
                onSelect={this.setInitialReportTag}
                profile={profile}
                selectedTeamMembership={selectedTeamMembership}
                teams={teamsMap}
                teamMembers={teamMembers}
                teamInvites={teamInvites}
                createInvite={createInvite}
                deleteInvite={deleteInvite}
                handleDisableMember={this.handleDisableMember}
                viewerIsTeamAdmin={viewerIsTeamAdmin}
                goals={goals}
                span={span}
                updateMemberRole={updateMemberRole}
            />
        )
    }

    profileToUser = (profile) => {
        return {
            id: profile.id,
            primaryEmail: profile.email.address,
        }
    }

    renderModals(team, tagReportUser) {
        const { showTagReport, initialReportTag } = this.state
        const { tags, tagReports, clearTagReports, recentTagCombos, queryTagReports,
            teams, selectedTeamMembership, currentInvite, downloadCsv, pushReportToZapier, webhookSubscriptions } = this.props
        const teamsMap = teams.items
        const { interval, increment, ...span } = this.props.viewport.range

        const tagReportNow = new Date(span.start)
        const intervalToUse = interval === 'Day' ? 'Week' : interval
        const teamMembers = selectedTeamMembership.sort.reduce( (acc, k) => [...acc, selectedTeamMembership.items[k]], []) || []
        const viewerIsTeamAdmin = this.viewerIsTeamAdmin()
        const showCurrentInvite = !!currentInvite
        
        return (
            <div>
                {showTagReport && <TagReportModal
                    toggleTagReport={this.toggleTagReport}
                    initialReportTag={initialReportTag}
                    tags={tags}
                    tagReports={tagReports}
                    clearTagReports={clearTagReports}
                    recentTagCombos={recentTagCombos}
                    queryTagReports={queryTagReports}
                    team={team}
                    teams={teamsMap}
                    downloadCsv={downloadCsv}
                    pushReportToZapier={pushReportToZapier}
                    user={tagReportUser}
                    now={tagReportNow}
                    interval={intervalToUse}
                    teamMembers={viewerIsTeamAdmin ? teamMembers : undefined}
                    webhookSubscriptions={webhookSubscriptions}
                />}
                {showCurrentInvite && <AcceptInviteModal 
                    currentInvite={currentInvite} 
                    cancel={()=>this.props.setCurrentInvite(null)} 
                />}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/pages/dashboard.jsx